import { useFormContext } from 'react-hook-form'
import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@cocoonspace/ui/components/alert-dialog'
import { useLingui } from '@lingui/react/macro'

import {
	BookingWindowForm,
	type EditBookingWindowFormData,
} from './booking-window-form'
import type { EditEventTypeFormData } from './../event-type-form'

export const EditBookingWindowDialog = ({
	open,
	onOpenChange,
}: {
	open: boolean
	onOpenChange: (open: boolean) => void
}) => {
	const { t } = useLingui()
	const form = useFormContext<EditEventTypeFormData>()

	const handleSubmit = (data: EditBookingWindowFormData) => {
		form.setValue('bookingWindow', data, {
			shouldDirty: true,
		})

		onOpenChange(false)
	}

	return (
		<AlertDialog
			open={open}
			onOpenChange={onOpenChange}
		>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{t`Editer les plages de dates`}</AlertDialogTitle>
				</AlertDialogHeader>

				<p className='text-sm'>
					{t`Définissez combien de temps à l'avance il est possible de réserver des rendez-vous avec vous.`}
				</p>

				<BookingWindowForm
					bookingWindow={form.getValues('bookingWindow')}
					onSubmit={handleSubmit}
					onClose={() => onOpenChange(false)}
				/>
			</AlertDialogContent>
		</AlertDialog>
	)
}
